module.exports = __webpack_public_path__ + "img/8.708b2536.jpg";